import { render, staticRenderFns } from "./ComboboxSingle.vue?vue&type=template&id=168048a1"
import script from "./ComboboxSingle.vue?vue&type=script&lang=js"
export * from "./ComboboxSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports